/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) {
        this.inputs = [];
        return;
      }
      this.inputs = this.form.querySelectorAll('select[name="locale_code"], select[name="country_code"]');
      this.inputs.forEach((item) => {
        item.addEventListener('change', (event) => this.onSubmitHandler(event));
      });
      this.initFlags();
      this.initDropdowns();
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
    initFlags() {
      if (!this.inputs || !this.inputs.length) return;

      this.inputs.forEach((select) => {
        this.updateFlagForSelect(select);
        select.addEventListener('change', () => {
          this.updateFlagForSelect(select);
        });
      });
    }
    initDropdowns() {
      this.dropdowns = this.querySelectorAll('.localization-select');
      if (!this.dropdowns.length) return;

      this.dropdowns.forEach((dropdown) => {
        this.bindDropdown(dropdown);
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) {
          this.closeAllDropdowns();
        }
      });
    }
    bindDropdown(dropdown) {
      const toggle = dropdown.querySelector('.localization-toggle');
      const menu = dropdown.querySelector('.localization-menu');
      const items = dropdown.querySelectorAll('.localization-option');
      const select = dropdown.querySelector('select[data-localization-select]');

      if (!toggle || !menu || !items.length || !select) return;

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          this.closeDropdown(dropdown);
        } else {
          this.closeAllDropdowns();
          this.openDropdown(dropdown);
        }
      });

      items.forEach((item) => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          const value = item.dataset.value;
          const flag = item.dataset.flag || '';
          const iso = item.dataset.iso || (value ? value.slice(0, 2).toUpperCase() : '');

          select.value = value;

          const flagEl = dropdown.querySelector('.localization-toggle-flag');
          if (flagEl) {
            if (flag) {
              flagEl.style.backgroundImage = `url('${flag}')`;
              flagEl.hidden = false;
            } else {
              flagEl.hidden = true;
            }
          }

          const labelEl = dropdown.querySelector('.localization-toggle-label');
          if (labelEl && iso) {
            labelEl.textContent = iso;
          }

          items.forEach((el) => el.classList.remove('is-active'));
          item.classList.add('is-active');

          this.closeDropdown(dropdown);

          if (this.form) {
            this.form.submit();
          }
        });
      });
    }
    openDropdown(dropdown) {
      const toggle = dropdown.querySelector('.localization-toggle');
      const menu = dropdown.querySelector('.localization-menu');
      if (!toggle || !menu) return;
      dropdown.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    closeDropdown(dropdown) {
      const toggle = dropdown.querySelector('.localization-toggle');
      const menu = dropdown.querySelector('.localization-menu');
      if (!toggle || !menu) return;
      dropdown.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
    closeAllDropdowns() {
      if (!this.dropdowns) return;
      this.dropdowns.forEach((dropdown) => {
        this.closeDropdown(dropdown);
      });
    }
    updateFlagForSelect(select) {
      if (!select || !select.selectedOptions || !select.selectedOptions.length) return;
      const option = select.selectedOptions[0];
      const flagUrl = option.dataset.flag;
      const wrapper = select.closest('.select');

      if (!wrapper) return;

      if (flagUrl) {
        wrapper.classList.add('localization-has-flag');
        wrapper.style.setProperty('--language-flag-image', `url('${flagUrl}')`);
      } else {
        wrapper.classList.remove('localization-has-flag');
        wrapper.style.removeProperty('--language-flag-image');
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);
}